// Docs: https://git.parcelperform.com/dev-team/pm_insights/-/blob/phoenix/static/api/openapi-schema.yml
import getConfig from 'next/config';
import { baseFetcher } from '../base.fetchers';
const { publicRuntimeConfig } = getConfig();
const BASE_URL = `${publicRuntimeConfig.pmInsightsUrl}/insights/v1`;
export const pmInsights = baseFetcher(BASE_URL, true);
